<template>
    <div class="w-100">
        <label :for="id" class="pb-2 d-block font-weight-medium text-size-md">
            {{ label }}
        </label>
        <phone-input
            :id="id"
            v-model="phoneModel"
            :label="label"
            :disabled="disabled"
            color="primary"
            hide-details="auto"
            :rules="validationRules"
        />
    </div>
</template>

<script setup lang="ts">
import { PhoneDto } from '../../types';
import { useValidation } from '../../composables';
import { PhoneInput } from '@geta/kolumbus-frontend/components';
import { DEFAULT_COUNTRY } from '../../constants';

const props = withDefaults(defineProps<IPhoneField>(), {
    disabled: false
});

const { createMatchValidator, phoneNumberRules } = useValidation(props);

const isReferenceValue = props.referenceValue !== undefined;

const validationRules = [
    phoneNumberRules.phoneNumberRequired,
    phoneNumberRules.phoneNumberValid,
    ...(isReferenceValue ? [createMatchValidator(props.referenceErrorLabel)] : [])
];

const phoneModel = defineModel<PhoneDto>('modelValue', {
    required: true,
    default: {
        countryCode: DEFAULT_COUNTRY.PHONE_CODE
    } as PhoneDto
});

interface IPhoneField {
    id: string;
    disabled?: boolean;
    label: string;
    referenceValue?: PhoneDto | undefined;
    referenceErrorLabel?: string;
}
</script>
